import Axios from "../../helpers/axios";

export const getAllRoles = () => {
  return Axios.get("/roles");
};